import { useCallback } from "react";
import StringUtils from "../../../../../utilities/string-utils";

const useInputId = (idPrefix: string = "") => {
  const generateInputId = useCallback(
    (inputLabel: string) => {
      return (
        idPrefix +
        StringUtils.removeSpacesAndSpecialCharacters(inputLabel).toLowerCase()
      );
    },
    [idPrefix]
  );

  return {
    generateInputId
  };
};

export default useInputId;
